import React, { createContext, useContext, useState } from 'react';
import type { CallLog, VoiceAgent } from '../features/voice/voice.types';

export interface CallDetailPanelData {
  call: CallLog;
  agents: VoiceAgent[];
}

interface CallDetailPanelContextValue {
  callDetailPanel: CallDetailPanelData | null;
  setCallDetailPanel: React.Dispatch<React.SetStateAction<CallDetailPanelData | null>>;
}

const CallDetailPanelContext = createContext<CallDetailPanelContextValue>({
  callDetailPanel: null,
  setCallDetailPanel: () => {},
});

export const CallDetailPanelProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [callDetailPanel, setCallDetailPanel] = useState<CallDetailPanelData | null>(null);
  return (
    <CallDetailPanelContext.Provider value={{ callDetailPanel, setCallDetailPanel }}>
      {children}
    </CallDetailPanelContext.Provider>
  );
};

export const useCallDetailPanel = () => useContext(CallDetailPanelContext);
